import {
    listOrganizationGroups,
    organizationGroupQueryKeys,
    useOrganizationGroup,
    type IOrganizationGroupListItem,
} from "@/api/organization-groups";
import { usePagedEntity } from "@/api/usePagedEntity";
import {
    EntityCombobox,
    type EntityComboboxConfig,
    type EntityComboboxProps,
} from "./EntityCombobox";

const GROUPS_PAGE_SIZE = 50;

const groupComboboxConfig: EntityComboboxConfig<IOrganizationGroupListItem> = {
    pageSize: GROUPS_PAGE_SIZE,
    copy: {
        searchPlaceholder: "Search groups",
        loadingList: "Loading groups…",
        listError: "Couldn't load groups.",
        noResults: "No groups found",
        loadingSelected: "Loading selected group…",
        selectedNotFound: "The selected group was not found.",
        selectedError: "Couldn't load the selected group.",
        chooseRequired: "Choose a group.",
        triggerLoading: "Loading group…",
        triggerNotFound: "Group not found",
        triggerUnavailable: "Group unavailable",
        triggerEmpty: "Select a group",
    },
    usePages: ({ pageCount, size, search, enabled }) =>
        usePagedEntity<IOrganizationGroupListItem>({
            pageCount,
            size,
            search,
            enabled,
            queryKey: ({ page, size: pageSize, search: normalizedSearch }) =>
                organizationGroupQueryKeys.list({
                    page,
                    size: pageSize,
                    search: normalizedSearch,
                }),
            queryFn: ({ page, size: pageSize, search: normalizedSearch }) =>
                listOrganizationGroups({
                    page,
                    size: pageSize,
                    search: normalizedSearch,
                }),
        }),
    useSelected: (id) => useOrganizationGroup(id),
};

export type GroupComboboxProps = EntityComboboxProps;

export function GroupCombobox(props: GroupComboboxProps) {
    return <EntityCombobox config={groupComboboxConfig} {...props} />;
}
